import React from "react";
import { Input as AntInput } from 'antd';

const componentClass = 'fieldType__input';

const Input = ({ onChange, value, ...rest }) => {
  return <AntInput
      className={componentClass}
      onChange={e => onChange(e.target.value)}
      value={value}
      {...rest}
  />
}
export default Input;
